import LocalStorageActor from './LocalStorageActor'

const localStorageKey = 'offerFilters'

class OfferFilters extends LocalStorageActor {
  constructor(offerId) {
    super(localStorageKey)

    this.offerId = offerId
  }

  apply(filters) {
    const filterData = this.getData([this.offerId])
    if (filterData) {
      Object.entries(filterData).forEach(([key, value]) => {
        // eslint-disable-next-line no-param-reassign
        filters[key] = value
      })
    }
    return filters
  }

  update(filters) {
    this.setData([this.offerId.toString()], filters)
  }

  static clear() {
    LocalStorageActor.clear(localStorageKey)
  }
}

export default OfferFilters
